import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { useSearchGroups, useLoadGroup } from "src/hooks/useSearchGroups";
import TeamDropdown from "src/components/TeamDropdown";
import { resolveGroupTypeFilter } from "src/util/tagGroupTypes";
import { useGroupTypes } from "src/contexts/global/WorkspaceContext/WorkspaceContext";

const TagAttributeGroupSelect = ({
  id = "tag-attribute-group-select",
  label,
  onSelectGroup,
  value,
  group,
  associatedValue: groupTypes,
  resolvedTeamTypeIds, // New prop for pre-resolved team type IDs
  disabled,
  invalid,
  mandatory,
  focus,
}) => {
  const [selectedOption, setSelectedOption] = useState<{
    label?: string;
    value?: string;
  } | null>(null);
  const allGroupTypes = useGroupTypes();

  // Use pre-resolved team type IDs if available, otherwise resolve from groupTypes
  const resolvedGroupTypes =
    resolvedTeamTypeIds || resolveGroupTypeFilter(groupTypes, allGroupTypes);

  const { loadOptions, isSearching } = useSearchGroups({
    groupTypes: resolvedGroupTypes,
    includeMembers: false,
    hideHidden: true,
    fetchPolicy: "cache-first",
  } as Record<string, unknown>);
  const { loadGroup, isLoading } = useLoadGroup();

  useEffect(() => {
    if (group) {
      setSelectedOption({
        label: group.name,
        value,
      });
    } else if (value) {
      loadGroup(value).then((loadedGroup) => {
        if (!loadedGroup) {
          return;
        }
        setSelectedOption({
          label: loadedGroup.name,
          value,
        });
      });
    } else {
      setSelectedOption(null);
    }
  }, [group, loadGroup, value]);

  return (
    <TeamDropdown
      id={id}
      label={label}
      placeholder="Find and select team"
      isSearchable
      isLoading={isSearching || isLoading}
      isDisabled={disabled}
      options={true}
      loadOptions={loadOptions}
      onSelectTeam={onSelectGroup}
      value={selectedOption}
      cacheOptions={false}
      invalid={invalid}
      mandatory={mandatory}
      focus={focus}
      isClearable={!disabled}
    />
  );
};

TagAttributeGroupSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  associatedValue: PropTypes.array,
  value: PropTypes.string,
  group: PropTypes.object,
  onSelectGroup: PropTypes.func,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  mandatory: PropTypes.bool,
  focus: PropTypes.bool,
  resolvedTeamTypeIds: PropTypes.array,
};
export default TagAttributeGroupSelect;
